import { ServerEnvironment } from '../../../components/servers-grid/shared'

export interface LegacyServerEnvironmentItem {
  readonly value: ServerEnvironment
  readonly name: 'Development' | 'QA' | 'Production'
}

export const SERVER_ENVIRONMENT_LIST: LegacyServerEnvironmentItem[] = [
  { value: 'DEVELOPMENT', name: 'Development' },
  { value: 'QA', name: 'QA' },
  { value: 'PRODUCTION', name: 'Production' }
]
